import React, { useRef } from "react";
import emailjs from "@emailjs/browser";
import { MdOutlineEmail } from "react-icons/md";
import { RiLinkedinLine } from "react-icons/ri";
import { BsWhatsapp } from "react-icons/bs";
import "./contact.css";

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        `${process.env.REACT_APP_SERVICE_ID}`,
        `${process.env.REACT_APP_TEMPLATE_ID}`,
        form.current,
        `${process.env.REACT_APP_USER_ID}`
      )
      .then(
        (result) => {
          console.log(result.text);
          console.log("message sent");
          e.target.reset();
        },
        (error) => {
          console.log(error.text);
        }
      );
  };
  return (
    <section id="contact" className="card-container">
      <h5>Get In Touch</h5>
      <h2>Contact Me</h2>

      <div className="container contact__container">
        <div className="contact__options">
          <article className="contact__option">
            <MdOutlineEmail className="contact__option-icon" />
            <h4>Email</h4>
            <h5>tejaspatne18@gmail.com</h5>
            <a href="mailto:tejaspatne18@gmail.com" target="_blank" rel="noreferrer">
              Let’s Talk
            </a>
          </article>

          <article className="contact__option">
            <RiLinkedinLine className="contact__option-icon" />
            <h4>LinkedIn</h4>
            <h5>Tejas Patne</h5>
            <a href="https://www.linkedin.com/in/tejas-patne/" target="_blank" rel="noreferrer">
              Let's Connect
            </a>
          </article>

          <article className="contact__option">
            <BsWhatsapp className="contact__option-icon" />
            <h4>Whatsapp</h4>
            <h5>+91 8169622343</h5>
            <a href="https://api.whatsapp.com//send?phone=+918169622343" target="_blank" rel="noreferrer" >
              Let’s Chat
            </a>
          </article>
        </div>

        {/* <form action="">
          <input
            type="text"
            name="name"
            placeholder="Your Full Name"
            required
          />
          <input type="text" name="email" placeholder="Your Email" required />
          <textarea
            name="message"
            rows="7"
            placeholder="Your Message"
            required
          ></textarea>
          <button type="submit" className="btn btn-primary">
            Send message
          </button>
        </form> */}

        <form ref={form} onSubmit={sendEmail}>
          <input type="text" name="user_name" placeholder="Full Name" required />
          <input type="email" name="user_email" placeholder="Email Address" required />
          <textarea name="message" rows="7" placeholder="Your Message" required />
          <input type="submit" className="btn btn-primary" value="Send" />
        </form>
      </div>
    </section>
  );
};

export default Contact;
